import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { apiClient } from "../../../api/httpClient";
import { getRegisterVariant } from "../registerPageConfig";
import { useRegister } from "./useRegister";

/**
 * PG contact invitation flow: prefetch profile-completion, then delegate to useRegister('pgContact').
 */
export function usePgContactRegister() {
  const { token } = useParams();
  const config = useMemo(() => getRegisterVariant("pgContact"), []);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [profileCompletion, setProfileCompletion] = useState(null);

  const includePhoneField = !loadingProfile && !profileCompletion?.phone_number;

  const reg = useRegister("pgContact", {
    tokenFromRoute: token,
    includePhoneField,
  });

  useEffect(() => {
    const fetchProfileCompletion = async (t) => {
      try {
        const response = await apiClient(config.profileCompletionPath(t), "GET");
        setProfileCompletion(response);
      } catch {
        toast.error("Failed to load profile information. Please try again.");
      } finally {
        setLoadingProfile(false);
      }
    };

    if (token) {
      fetchProfileCompletion(token);
    } else {
      setLoadingProfile(false);
    }
  }, [token, config]);

  return {
    ...reg,
    loadingProfile,
    profileCompletion,
    /** Show masked phone column when profile still needs phone. */
    showPgPhoneMask: includePhoneField,
  };
}
